import React from 'react';
import Icon from 'icon';
import { Link } from 'gatsby';
import s from './scratched.module.scss';

export default function ScratchedNavItem({ category, href, dark, darkHover, ...props }) {
  const darkClass = dark ? s.dark : '';
  const darkHoverClass = darkHover ? s.darkHover : '';
return (
  <Link to={`${href}`} className={`${s.link} ${darkClass} ${darkHoverClass}`}>
    <span className={`${s[category?.toLowerCase()]} ${s.linkText} `}>
      {category}
    </span>
    <Icon icon="readmorearrow" />
  </Link>
);
}
